import { render } from "./LandingWaitList.vue?vue&type=template&id=ec4e7e24&scoped=true"
import script from "./LandingWaitList.vue?vue&type=script&lang=js"
export * from "./LandingWaitList.vue?vue&type=script&lang=js"

import "./LandingWaitList.vue?vue&type=style&index=0&id=ec4e7e24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec4e7e24"]])

export default __exports__